import React from "react";
import axios from "axios";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DeleteOutlineTwoToneIcon from "@mui/icons-material/DeleteOutlineTwoTone";
import { toast } from "react-toastify";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

const DeleteUserBtn = ({ userId, onDelete }) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = async () => {
    try {
      const response = await axios.delete(
        `/api/v1/delete-admin-users/${userId}`
      );

      if (response.status === 200) {
        toast.success("User successfully deleted");
        if (onDelete) {
          onDelete(userId); // Remove user from UI
        }
      } else {
        toast.error("Failed to delete user. Please try again.");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Error deleting user.");
    } finally {
      handleClose();
    }
  };

  return (
    <>
      <Tooltip title="Delete User">
        <IconButton
          onClick={handleClickOpen}
          sx={{
            color: "#d32f2f",
            "&:hover": {
              backgroundColor: "rgba(211, 47, 47, 0.1)",
            },
          }}
        >
          <DeleteOutlineTwoToneIcon />
        </IconButton>
      </Tooltip>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure you want to delete this user?"}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDelete} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteUserBtn;